import React, { useContext, useState, useRef, useEffect } from 'react';
import { LanguageContext } from './LanguageContext';
import './LanguageSwitcher.css';
import AboutusPhone from '../../images/language-arrow.svg'
// Only the flags the switcher shows. The react-world-flags package this
// replaced bundled every country's flag — about 70% of the site's JavaScript.
import flagUs from '../../images/flags/us.svg';
import flagGe from '../../images/flags/ge.svg';
import flagRu from '../../images/flags/ru.svg';
import flagEs from '../../images/flags/es.svg';
import flagTr from '../../images/flags/tr.svg';
import flagFr from '../../images/flags/fr.svg';
import flagDe from '../../images/flags/de.svg';

const languages = [
  { code: 'en', name: 'English', flag: flagUs },
  { code: 'ge', name: 'ქართული', flag: flagGe },
  { code: 'ru', name: 'Русский', flag: flagRu },
  { code: 'es', name: 'Español', flag: flagEs },
  { code: 'tr', name: 'Türkçe', flag: flagTr },
  { code: 'fr', name: 'Français', flag: flagFr },
  { code: 'de', name: 'Deutsch', flag: flagDe },
];

const LanguageSwitcher = () => {
  const { changeLanguage, selectedLanguage } = useContext(LanguageContext);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const switcherRef = useRef(null);

  const handleToggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };

  const handleLanguageChange = (code) => {
    changeLanguage(code);
    setDropdownOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (switcherRef.current && !switcherRef.current.contains(e.target)) {
        setDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const selectedLang = languages.find((lang) => lang.code === selectedLanguage);

  return (
    <div className="language-switcher" ref={switcherRef}>
      <div className="language-button" onClick={handleToggleDropdown}>
        <img src={selectedLang.flag} className="flag-icon" alt={`${selectedLang.name} flag`} />
        <span>{selectedLang.code.toUpperCase()}</span>
        <span className={`arrow ${dropdownOpen ? 'arrow-open' : ''}`}><img src={AboutusPhone} alt="" /></span>
      </div>

      {dropdownOpen && (
        <ul className="language-dropdown">
          {languages.map((lang) => (
            <li
              key={lang.code}
              className={`language-dropdown-item ${lang.code === selectedLanguage ? 'language-dropdown-item-active' : ''}`}
              onClick={() => handleLanguageChange(lang.code)}
            >
              <img src={lang.flag} className="flag-icon" alt="" />
              <span>{lang.name}</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default LanguageSwitcher;
